import { useState, useEffect, useContext } from 'react';
import LoadingLottie from "../../assets/Lottie/loadding.json";
import LoadingLottie2 from "../../assets/Lottie/find.json";
import Lottie from 'lottie-react';
import automatically from "../../assets/Image/automatically.png";
import PaymentLogo from "../../assets/Image/payment.png";
import CouponLogo from "../../assets/Image/coupon.png";
import { MyContext } from '../../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';
import { socket } from '../../socket';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const getTooltipText = (id, fareCalculate, currency) => {
    const cur = currency || "$";
    switch (id) {
        case 1: 
            return `Total distance calculated: ${fareCalculate?.tot_km || 0} km.`;
        case 2: 
            return `Estimated hours required: ${fareCalculate?.tot_hour || 0} hr.`;
        case 3: 
            return `Estimated ride duration: ${fareCalculate?.tot_minute || 0} min.`;
        case 4: {
            const rate = fareCalculate?.extra_charge_rate || 0;
            return `Extra surcharge: ${cur}${rate} = ${cur}${fareCalculate?.extra_charge || 0}.`;
        }
        case 5: {
            const isFix = fareCalculate?.weather_type?.trim()?.toLowerCase() === 'fix';
            const rate = fareCalculate?.weather_price || 0;
            return `Weather surcharge: ${isFix ? `${cur}${rate} fixed` : `${rate}% of subtotal`} = ${cur}${fareCalculate?.weather_charge || 0}.`;
        }
        case 6: {
            const passengerPrice = fareCalculate?.per_person_price || 0;
            const count = fareCalculate?.num_passenger || 0;
            return `Passenger fee: ${count} passenger(s) × ${cur}${passengerPrice} = ${cur}${fareCalculate?.extra_person_charge || 0}.`;
        }
        case 7: 
            return `Premium day booking charge: ${cur}${fareCalculate?.day_charge || 0}.`;
        case 8: {
            const hourRate = fareCalculate?.per_hour_charge || 0;
            const hours = fareCalculate?.rent_hour || 0;
            return `Rental hours: ${hours} hr × ${cur}${hourRate}/hr = ${cur}${fareCalculate?.hour_charge || 0}.`;
        }
        case 9: {
            const discountRate = fareCalculate?.per_hour_discount_rate || 0;
            const hours = fareCalculate?.rent_hour || 0;
            return `Discount: ${hours} hr × ${cur}${discountRate}/hr = -${cur}${fareCalculate?.per_hour_discount || 0}.`;
        }
        case 10: {
            if (fareCalculate?.min_km_distance !== undefined) {
                const minKm = fareCalculate?.min_km_distance || 0;
                const minPrice = fareCalculate?.min_km_price || 0;
                const afterPrice = fareCalculate?.after_km_price || 0;
                const distance = fareCalculate?.tot_km || 0;
                if (distance <= minKm) {
                    return `Base fare: ${distance} km × ${cur}${minPrice}/km (within base ${minKm} km) = ${cur}${fareCalculate?.km_charge || 0}.`;
                } else {
                    const addKm = (distance - minKm).toFixed(2);
                    const baseCharge = (minKm * minPrice).toFixed(2);
                    const extraCharge = (addKm * afterPrice).toFixed(2);
                    return `Distance: Base (${minKm} km × ${cur}${minPrice}/km) + Extra (${addKm} km × ${cur}${afterPrice}/km) = ${cur}${baseCharge} + ${cur}${extraCharge} = ${cur}${fareCalculate?.km_charge || 0}.`;
                }
            }
            const rate = fareCalculate?.up_to_fee || 0;
            const distance = fareCalculate?.tot_km || 0;
            return `Distance fee: ${distance} km × ${cur}${rate}/km = ${cur}${fareCalculate?.km_charge || 0}.`;
        }
        case 11: {
            const rate = fareCalculate?.per_kg_price || 0;
            const weight = fareCalculate?.kg || 0;
            return `Weight fee: ${weight} kg × ${cur}${rate}/kg = ${cur}${fareCalculate?.kg_charge || 0}.`;
        }
        case 12: {
            const rate = fareCalculate?.comission_rate || 0;
            const isFix = fareCalculate?.comission_type?.trim()?.toLowerCase() === 'fix';
            return `Platform commission: ${isFix ? `${cur}${rate} fixed` : `${rate}% fee`} = ${cur}${fareCalculate?.site_commission || 0}.`;
        }
        default: return "";
    }
};

const PriceModel = ({ data, setData, setShowModel, setIsModel, selectPayment, selectCoupon, setSelectCoupon, pickupLocation, dropLocation, stopList, handleCancelRequest, handleRequestTimeOut }) => {
    const { t } = useTranslation();
    const { handleCallApi, setShowToast, setToastMsg, biddingList, handleFetchRunningRide } = useContext(MyContext);
    const navigate = useNavigate();
    const params = useParams();
    const m_role = data?.m_role ? Number(data.m_role) : (params.title === "outstation" ? 2 : params.title === "hourly-rental" ? 3 : params.title === "package" ? 4 : 1);

    const [toggle, setToggle] = useState(false);
    const [input, setInput] = useState(data?.drop_price || data?.tot_price);
    const [isRunning, setIsRunning] = useState(false);
    const [time, setTime] = useState(null);
    const [allLocation, setAllLoation] = useState([]);

    const [isFareBreakdownOpen, setIsFareBreakdownOpen] = useState(false);
    const [walletBalance, setWalletBalance] = useState(0);
    const [useWallet, setUseWallet] = useState(false);
    const [isTimeoutTriggered, setIsTimeoutTriggered] = useState(false);
    const [requestId, setRequestId] = useState(null);
    const [activeRole, setActiveRole] = useState("");
    const [isTimerReady, setIsTimerReady] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsTimerReady(true);
        }, 1500);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        const fetchWallet = async () => {
            const uid = secureLocalStorage.getItem("Userid");
            if (uid) {
                const res = await handleCallApi("Post", "customer/wallet", { uid });
                if (res?.data?.ResponseCode === 200) {
                    setWalletBalance(Number(res.data.wallet_amount) || 0);
                }
            }
        };
        fetchWallet();
    }, []);
    
    const [isScheduled, setIsScheduled] = useState(false);
    const [scheduleDate, setScheduleDate] = useState(() => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    });
    const [scheduleTime, setScheduleTime] = useState(() => {
        const today = new Date();
        today.setHours(today.getHours() + 1);
        const hours = String(today.getHours()).padStart(2, '0');
        const minutes = String(today.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    });



    const currency = secureLocalStorage.getItem("currency");

    const role = activeRole || (data?.m_role ? data.m_role.toString() : "");
    let DefultTime = 140; // Default for regular ride
    if (role === '2' || params.title === "outstation") {
        DefultTime = Number(secureLocalStorage.getItem("out_offer_exprie_time_cus")) || 60;
    } else if (role === '3' || params.title === "hourly-rental") {
        DefultTime = Number(secureLocalStorage.getItem("ren_offer_exprie_time_cus")) || 100;
    } else if (role === '4' || params.title === "package") {
        DefultTime = Number(secureLocalStorage.getItem("pack_offer_exprie_time_cus")) || 60;
    }

    useEffect(() => {
        const locations = [
            { type: "Pickup", ...pickupLocation },
            { type: "Drop", ...dropLocation },
            ...stopList
        ];
        setAllLoation(locations);
    }, []);

    useEffect(() => {
        if (data && (time === null || time === undefined)) {
            if (data.increased_time !== undefined && data.increased_time !== null) {
                setIsRunning(true);
                setTime(Number(data.increased_time));
                if (data.m_role) {
                    setActiveRole(data.m_role.toString());
                }
                if (data.id) {
                    setRequestId(data.id);
                }
                setToggle(data?.bidd_auto_status === "1" ? true : false);
            }
        }
    }, [data, time]);

    useEffect(() => {
        if (!isRunning) return;
        const interval = setInterval(() => {
            setTime(prev => (prev === null || prev === undefined) ? null : prev - 1);
        }, 1000);
        return () => clearInterval(interval);
    }, [isRunning]);

    useEffect(() => {
        if (time !== null && isRunning && time > 0) {
            setIsTimeoutTriggered(false);
        }

        if (time !== null && time <= 0 && isRunning) {
            setIsRunning(false);
            setTime(0);
        }

        if (time !== null && time <= 0 && !isRunning && !isTimeoutTriggered && isTimerReady) {
            const hasActiveRequest = data?.bidding_run_status == 1 || data?.id || data?.request_id;
            if (hasActiveRequest && (!biddingList || biddingList.length === 0)) {
                setIsTimeoutTriggered(true);
                setShowModel("Busy");
                if (handleRequestTimeOut) {
                    handleRequestTimeOut(requestId || data?.id || data?.request_id);
                }
            }
        }
    }, [time, biddingList, isRunning, isTimeoutTriggered, data, isTimerReady]);

    useEffect(() => {
        setData({ ...data, bid_addjust_amount: input });
        if (selectCoupon?.min) {
            if (input < selectCoupon?.min) {
                setSelectCoupon(null);
            }
        }
    }, [input]);

    const handleCheckAmount = () => {

        if (data?.bidding === "0") {
            return true;
        }

        const Amount = Number(Math.round(input));

        if (Amount < Number(data.minimum_fare)) {
            setShowToast(true);
            setToastMsg(`${t("Minimum fare is")} ${currency + data.minimum_fare}`)
            return false;
        }

        if (Amount > Number(data.maximum_fare)) {
            setShowToast(true);
            setToastMsg(`${t("Maximum fare is")} ${currency + data.maximum_fare}`)
            return false;
        }

        return true;
    }

    const handleIncresdDencres = async (index) => {
        const IsCheck = await handleCheckAmount();

        if (!IsCheck || isRunning) return;

        let Amount = input;

        if (index === 1) {
            Amount -= 1;
        } else {
            Amount += 1;
        }

        setInput(Amount);
    }

    const handleContinue = () => {

        if (params.title === "outstation") {
            handleBookOutstation();
            return;
        }

        if (params.title === "hourly-rental") {
            handleBookHourlyRental();
            return;
        }

        if (params.title === "package") {
            handlePackage();
            return;
        }

        handleBooking();
    }

    const handleBooking = async () => {

        const IsCheck = await handleCheckAmount();

        if (!IsCheck) return;
        const uid = secureLocalStorage.getItem("Userid");

        const ApiBody = {
            uid,
            vehicle_id: data.id,
            tot_km: data?.tot_km || data?.drop_km,
            tot_hour: (data?.tot_hour || data?.drop_hour) || 0,
            tot_minute: data?.tot_minute || data?.drop_time,
            bidding: data?.bidding,
            bidd_auto_status: toggle,
            drop_price: data?.drop_price,
            bid_addjust_amount: data?.bid_addjust_amount,
            km_charge: data?.km_charge,
            extra_charge: data?.extra_charge,
            weather_charge: data?.weather_charge,
            extra_person_charge: data?.extra_person_charge,
            site_commission: data?.site_commission,
            coupon_id: selectCoupon?.id || "",
            payment_id: selectPayment?.id,
            zone: data?.zone,
            pickup: `${pickupLocation?.lat},${pickupLocation?.lng}`,
            drop: `${dropLocation?.lat},${dropLocation?.lng}`,
            pickupadd: {
                title: pickupLocation?.title,
                subt: pickupLocation?.subt
            },
            dropadd: {
                title: dropLocation?.title,
                subt: dropLocation?.subt
            },
            droplist: stopList.map((item) => ({ lat: item.lat, long: item.lng })),
            droplistadd: stopList.map((item) => ({ title: item.title, subt: item.subt })),
            book_date: isScheduled ? scheduleDate : "",
            book_time: isScheduled ? scheduleTime : ""
        }

        const Response = await handleCallApi("Post", "customer/add_vehicle_request", ApiBody);
        setShowToast(true);
        setToastMsg(Response.data.message);
        if (Response.data.ResponseCode === 200) {
            if (isScheduled) {
                setShowModel(null);
                navigate("/my-rides", { state: { tab: "scheduled" } });
            } else {
                setIsRunning(true);
                setTime(DefultTime);
                setRequestId(Response.data.id);
                setActiveRole(m_role.toString());
                const SocketBody = {
                    requestid: Response.data.id,
                    m_role: m_role,
                    driverid: Response.data.driver_id,
                    c_id: uid
                }
                socket.emit("vehiclerequest", SocketBody);
                handleFetchRunningRide();
            }
        }
    }

    const handleBookOutstation = async () => {
        const IsCheck = await handleCheckAmount();
        if (!IsCheck) return;
        const uid = secureLocalStorage.getItem("Userid");

        const ApiBody = {
            uid,
            outs_category_id: data?.outs_category_id,
            outs_id: data?.outs_id,
            vehicle_id: data?.vehicle_id || data?.id,
            num_passenger: data?.num_passenger,
            book_date: data?.book_date,
            book_time: data?.book_time,
            tot_km: data?.tot_km,
            tot_hour: data?.tot_hour,
            tot_minute: data?.tot_minute,
            tot_price: data?.tot_price,
            bid_addjust_amount: data?.bid_addjust_amount,
            km_charge: data?.km_charge,
            extra_charge: data?.extra_charge,
            weather_charge: data?.weather_charge,
            extra_person_charge: data?.extra_person_charge,
            day_charge: data?.day_charge,
            site_commission: data?.site_commission,
            coupon_id: selectCoupon?.id || "",
            payment_id: selectPayment?.id,
            bidd_status: data?.bidding,
            bidd_auto_status: toggle,
            zone: data?.zone,
            pickup_lat_lon: `${pickupLocation?.lat},${pickupLocation?.lng}`,
            drop_lat_lon: `${dropLocation?.lat},${dropLocation?.lng}`,
            pickupadd: {
                title: pickupLocation?.title,
                subt: pickupLocation?.subt
            },
            dropadd: {
                title: dropLocation?.title,
                subt: dropLocation?.subt
            },
            drop_lat_lon_list: stopList.map((item) => ({ lat: item.lat, long: item.lng })),
            droplistadd: stopList.map((item) => ({ title: item.title, subt: item.subt }))
        }

        const Response = await handleCallApi("Post", "cus_outs/send_request", ApiBody);
        setShowToast(true);
        setToastMsg(Response.data.message);
        if (Response.data.ResponseCode === 200) {
            setIsRunning(true);
            setTime(DefultTime);
            setRequestId(Response.data.id);
            setActiveRole(m_role.toString());
            const SocketBody = {
                requestid: Response.data.id,
                m_role: m_role,
                driverid: Response.data.driver_id,
                c_id: uid
            }
            socket.emit("vehiclerequest", SocketBody);
            handleFetchRunningRide();
        }
    }

    const handleBookHourlyRental = async () => {
        const IsCheck = await handleCheckAmount();
        if (!IsCheck) return;
        const uid = secureLocalStorage.getItem("Userid");

        const ApiBody = {
            uid,
            rental_id: data?.id,
            vehicle_id: data?.vehicle_id,
            book_date: data?.book_date,
            book_time: data?.book_time,
            rent_hour: data?.rent_hour,
            tot_km: data?.tot_km,
            tot_hour: data?.tot_hour,
            tot_minute: data?.tot_minute,
            tot_price: data?.tot_price,
            bid_addjust_amount: data?.bid_addjust_amount,
            hour_charge: data?.hour_charge,
            extra_charge: data?.extra_charge,
            weather_charge: data?.weather_charge,
            per_hour_discount: data?.per_hour_discount,
            site_commission: data?.site_commission,
            coupon_id: selectCoupon?.id || "",
            payment_id: selectPayment?.id,
            bidd_status: data?.bidding,
            bidd_auto_status: toggle,
            zone: data?.zone,
            pickup_lat_lon: `${pickupLocation?.lat},${pickupLocation?.lng}`,
            drop_lat_lon: `${dropLocation?.lat},${dropLocation?.lng}`,
            pickupadd: {
                title: pickupLocation?.title,
                subt: pickupLocation?.subt
            },
            dropadd: {
                title: dropLocation?.title,
                subt: dropLocation?.subt
            },
            drop_lat_lon_list: stopList.map((item) => ({ lat: item.lat, long: item.lng })),
            droplistadd: stopList.map((item) => ({ title: item.title, subt: item.subt }))

        }

        const Response = await handleCallApi("Post", "cus_rental/rental_send_request", ApiBody);
        setShowToast(true);
        setToastMsg(Response.data.message);
        if (Response.data.ResponseCode === 200) {
            setIsRunning(true);
            setTime(DefultTime);
            setRequestId(Response.data.id);
            setActiveRole(m_role.toString());
            const SocketBody = {
                requestid: Response.data.id,
                m_role: m_role,
                driverid: Response.data.driver_id,
                c_id: uid
            }
            socket.emit("vehiclerequest", SocketBody);
            handleFetchRunningRide();
        }
    }

    const handlePackage = async () => {

        const uid = secureLocalStorage.getItem("Userid");

        const ApiBody = {
            uid,
            package_id: data?.id,
            book_date: data?.book_date,
            book_time: data?.book_time,
            tot_km: data?.tot_km,
            tot_hour: data?.tot_hour,
            tot_minute: data?.tot_minute,
            tot_price: data?.tot_price,
            bid_addjust_amount: data?.bid_addjust_amount,
            km_charge: data?.km_charge,
            extra_charge: data?.extra_charge,
            weather_charge: data?.weather_charge,
            tot_kg: data?.kg,
            kg_charge: data?.kg_charge,
            site_commission: data?.site_commission,
            coupon_id: selectCoupon?.id || "",
            payment_id: selectPayment?.id,
            bidd_status: data?.bidding,
            bidd_auto_status: toggle,
            zone: data?.zone,
            sender_number: data?.sender_number,
            reciver_number: data?.reciver_number,
            length: data?.length,
            weight: data?.weight,
            height: data?.height,
            what_a_driver: data?.desc,
            pickup_lat_lon: `${pickupLocation?.lat},${pickupLocation?.lng}`,
            drop_lat_lon: `${dropLocation?.lat},${dropLocation?.lng}`,
            pickupadd: {
                title: pickupLocation?.title,
                subt: pickupLocation?.subt
            },
            dropadd: {
                title: dropLocation?.title,
                subt: dropLocation?.subt
            },
            drop_lat_lon_list: stopList.map((item) => ({ lat: item.lat, long: item.lng })),
            droplistadd: stopList.map((item) => ({ title: item.title, subt: item.subt })),
            image: data?.imageList
        }

        const Response = await handleCallApi("Post", "cus_package/package_send_request", ApiBody);
        setShowToast(true);
        setToastMsg(Response.data.message);
        if (Response.data.ResponseCode === 200) {
            setIsRunning(true);
            setTime(DefultTime);
            setRequestId(Response.data.id);
            setActiveRole(m_role.toString());
            const SocketBody = {
                requestid: Response.data.id,
                m_role: m_role,
                driverid: Response.data.driver_id,
                c_id: uid
            }
            socket.emit("vehiclerequest", SocketBody);
            handleFetchRunningRide();
        }
    }

    const hadnleDriverOffer = () => {
        const SocketBody = {
            uid: secureLocalStorage.getItem("Userid"),
            request_id: data?.id,
            d_id: data?.d_id,
            m_role: m_role
        }
        socket.emit("load_bidding_data", SocketBody);
    }

    const handleShowToast = () => {
        setShowToast(true);
        setToastMsg("Your current request is in progress. You can either wait for it to complete or cancel to perform this action.");
    }

    const getFareBreakdownList = () => {
        const list = [];
        if (data?.km_charge && Number(data.km_charge) > 0) {
            list.push({ label: t("Base Distance Charge"), value: Number(data.km_charge), id: 10 });
        }
        if (data?.hour_charge && Number(data.hour_charge) > 0) {
            list.push({ label: t("Base Hourly Charge"), value: Number(data.hour_charge), id: 8 });
        }
        if (data?.day_charge && Number(data.day_charge) > 0) {
            list.push({ label: t("Day Charge"), value: Number(data.day_charge), id: 7 });
        }
        if (data?.kg_charge && Number(data.kg_charge) > 0) {
            list.push({ label: t("Weight Charge"), value: Number(data.kg_charge), id: 11 });
        }
        if (data?.extra_charge && Number(data.extra_charge) > 0) {
            list.push({ label: t("Surcharges"), value: Number(data.extra_charge), id: 4 });
        }
        if (data?.extra_person_charge && Number(data.extra_person_charge) > 0) {
            list.push({ label: t("Extra Person Fee"), value: Number(data.extra_person_charge), id: 6 });
        }
        if (data?.weather_charge && Number(data.weather_charge) > 0) {
            list.push({ label: t("Weather Adjustment"), value: Number(data.weather_charge), id: 5 });
        }
        if (data?.site_commission && Number(data.site_commission) > 0) {
            list.push({ label: t("Platform Fee"), value: Number(data.site_commission), id: 12 });
        }
        return list;
    };

    const subtotal = Number(input) || 0;
    const couponDiscount = selectCoupon ? Number(selectCoupon.amt || 0) : 0;
    const walletDeduction = useWallet ? Math.min(walletBalance, Math.max(0, subtotal - couponDiscount)) : 0;
    const finalPayable = Math.max(0, subtotal - couponDiscount - walletDeduction);

    return <>

        <div className="flex items-center justify-between mb-2">
            <h1 className='font-medium text-[20px]'>
                {data?.bidding === "1" ? t("Set your price") : `${t("Finding a ride")} ${(isRunning && data?.name) ? `${t("for you")} ${data?.name} ${t("ride")}` : ""}`}
            </h1>
            <button onClick={() => isRunning ? handleShowToast() : setShowModel("FareCalculate")} className={`hover:bg-gray-100 rounded-full p-2 ${isRunning && "cursor-default"}`}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.414 12L18.707 6.70695C19.098 6.31695 19.098 5.68301 18.707 5.29301C18.316 4.90201 17.684 4.90201 17.293 5.29301L12 10.586L6.70701 5.29301C6.31601 4.90201 5.68401 4.90201 5.29301 5.29301C4.90201 5.68301 4.90201 6.31695 5.29301 6.70695L10.586 12L5.29301 17.293C4.90201 17.683 4.90201 18.3169 5.29301 18.7069C5.48801 18.9019 5.74401 19 6.00001 19C6.25601 19 6.51201 18.9019 6.70701 18.7069L12 13.414L17.293 18.7069C17.488 18.9019 17.744 19 18 19C18.256 19 18.512 18.9019 18.707 18.7069C19.098 18.3169 19.098 17.683 18.707 17.293L13.414 12Z" fill="currentColor" />
                </svg>
            </button>
        </div>

        {(data?.bidding === "1" && isRunning) && <Lottie
            className="w-[200px] mx-auto my-[10px]"
            animationData={LoadingLottie}
            loop={true}
        />}

        <div>

            {data?.bidding == "1" && <div>
                <p className="text-center text-gray-600">{t("💡 Raise the fare. increase your chance.")}</p>

                <div className="flex items-center justify-center gap-5 py-3">
                    <button onClick={() => isRunning ? handleShowToast() : handleIncresdDencres(1)} className={`p-2 bg-gray-200 rounded-full ${isRunning && "cursor-default"}`}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19 13H5C4.448 13 4 12.552 4 12C4 11.448 4.448 11 5 11H19C19.552 11 20 11.448 20 12C20 12.552 19.552 13 19 13Z" fill="black" />
                        </svg>
                    </button>
                    <input disabled={isRunning} type="number" value={input} onChange={(e) => setInput(Number(e.target.value))} className="w-[100px] border-b py-2 outline-none text-center font-semibold text-[18px]" />
                    <button onClick={() => isRunning ? handleShowToast() : handleIncresdDencres(2)} className={`p-2 bg-gray-200 rounded-full ${isRunning && "cursor-default"}`}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19 11H13V5C13 4.448 12.552 4 12 4C11.448 4 11 4.448 11 5V11H5C4.448 11 4 11.448 4 12C4 12.552 4.448 13 5 13H11V19C11 19.552 11.448 20 12 20C12.552 20 13 19.552 13 19V13H19C19.552 13 20 12.552 20 12C20 11.448 19.552 11 19 11Z" fill="black" />
                        </svg>
                    </button>
                </div>

                <div className="flex items-center justify-between gap-2">
                    <div className="flex items-center gap-2">
                        <img src={automatically} className="w-[40px]" alt="automatically" />
                        <p className="leading-5">{t("Automatically book the nearest")} <br /> {t("driver for")} ({currency + Number(input).toFixed(2)})</p>
                    </div>
                    <button onClick={() => isRunning ? handleShowToast() : setToggle(!toggle)} className={`w-[40px] h-[25px] ${toggle ? "bg-[--bg-color]" : "bg-gray-200"} rounded-[50px] flex items-center transition-colors ${isRunning && "cursor-default"}`}>
                        <div className={`w-[20px] h-[19px] bg-white rounded-full ${toggle ? "translate-x-4" : "translate-x-1"} transition-all`}></div>
                    </button>
                </div>
            </div>}


            {data?.bidding == "0" && <div>

                {isRunning && <div>
                    <Lottie
                        className="w-[200px] mx-auto"
                        animationData={LoadingLottie2}
                        loop={true}
                    />
                </div>}

                {!isRunning && <div>
                    {allLocation.map((item, index) => (
                        <div key={index} className="flex items-start gap-3">
                            <div className="flex flex-col items-center mt-[6px]">
                                <div
                                    className={`${item.type === "Pickup"
                                        ? "location-icon-green"
                                        : "location-icon-red"
                                        }`}
                                ></div>
                                {index !== allLocation.length - 1 && (
                                    <div className="h-6 border-l-2 border-dashed border-gray-400 mt-2"></div>
                                )}
                            </div>
                            <div className="leading-5">
                                <h1 className="font-medium text-gray-800 line-clamp-1">
                                    {item.title}
                                </h1>
                                <p className="text-[15px] text-gray-600">{item.subt}</p>
                            </div>
                        </div>
                    ))}
                </div>}

            </div>}


            {!(params.title === "outstation" || params.title === "hourly-rental" || params.title === "package") && (
                <div className="bg-gray-50 border border-gray-150 p-4 rounded-xl mt-4 mb-3 flex flex-col gap-3">
                    <div className="flex items-center justify-between">
                        <label className="font-semibold text-gray-800 text-[15px] cursor-pointer" htmlFor="scheduleLater">
                            {t("Schedule for Later")}
                        </label>
                        <button
                            id="scheduleLater"
                            onClick={() => isRunning ? handleShowToast() : setIsScheduled(!isScheduled)}
                            className={`w-[40px] h-[25px] ${isScheduled ? "bg-[--bg-color]" : "bg-gray-200"} rounded-[50px] flex items-center transition-colors ${isRunning && "cursor-default"}`}
                        >
                            <div className={`w-[20px] h-[19px] bg-white rounded-full ${isScheduled ? "translate-x-4" : "translate-x-1"} transition-all`}></div>
                        </button>
                    </div>
                    {isScheduled && (
                        <div className="flex gap-3">
                            <div className="flex-1 flex flex-col">
                                <label className="text-[12px] font-semibold text-gray-500 mb-1">{t("Select Date")}</label>
                                <input
                                    type="date"
                                    min={new Date().toISOString().split('T')[0]}
                                    value={scheduleDate}
                                    onChange={(e) => setScheduleDate(e.target.value)}
                                    className="border rounded-lg p-2 text-sm outline-none bg-white font-medium"
                                />
                            </div>
                            <div className="flex-1 flex flex-col">
                                <label className="text-[12px] font-semibold text-gray-500 mb-1">{t("Select Time")}</label>
                                <input
                                    type="time"
                                    value={scheduleTime}
                                    onChange={(e) => setScheduleTime(e.target.value)}
                                    className="border rounded-lg p-2 text-sm outline-none bg-white font-medium"
                                />
                            </div>
                        </div>
                    )}
                </div>
            )}

            {/* Wallet Toggle Option */}
            {walletBalance > 0 && (
                <div className="bg-gray-50 border border-gray-150 p-4 rounded-xl mt-2 mb-2 flex flex-col gap-3">
                    <div className="flex items-center justify-between">
                        <label className="font-semibold text-gray-800 text-[15px] cursor-pointer" htmlFor="useWalletToggle">
                            {t("Pay using Wallet")} ({currency + walletBalance.toFixed(2)})
                        </label>
                        <button
                            id="useWalletToggle"
                            onClick={() => isRunning ? handleShowToast() : setUseWallet(!useWallet)}
                            className={`w-[40px] h-[25px] ${useWallet ? "bg-[--bg-color]" : "bg-gray-200"} rounded-[50px] flex items-center transition-colors ${isRunning && "cursor-default"}`}
                        >
                            <div className={`w-[20px] h-[19px] bg-white rounded-full ${useWallet ? "translate-x-4" : "translate-x-1"} transition-all`}></div>
                        </button>
                    </div>
                </div>
            )}

            {/* Collapsible Fare Details Section */}
            <div className="bg-gray-50 border border-gray-150 rounded-xl mt-2 mb-2">
                <button
                    onClick={() => setIsFareBreakdownOpen(!isFareBreakdownOpen)}
                    className="w-full flex items-center justify-between p-4 font-semibold text-gray-800 text-[15px] outline-none"
                >
                    <span>{t("Fare Details")}</span>
                    <svg
                        className={`w-5 h-5 transform transition-transform duration-200 ${isFareBreakdownOpen ? "rotate-180" : ""}`}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
                {isFareBreakdownOpen && (
                    <div className="p-4 pt-0 border-t border-gray-100 flex flex-col gap-2 text-sm text-gray-600">
                        {getFareBreakdownList().map((item, idx) => (
                            <div key={idx} className="flex justify-between items-center py-0.5 relative group">
                                <div className="flex items-center gap-1.5">
                                    <span>{item.label}</span>
                                    <div className="relative flex items-center justify-center cursor-help text-gray-400 hover:text-gray-600 transition-colors">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2"/>
                                            <path d="M12 16V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                            <circle cx="12" cy="8" r="1.5" fill="currentColor"/>
                                        </svg>
                                        <div className="pointer-events-none opacity-0 group-hover:opacity-100 absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 w-64 p-2 bg-gray-900 text-white text-[11px] rounded-lg shadow-xl transition-all duration-200 z-50 text-center font-normal normal-case leading-relaxed">
                                            {getTooltipText(item.id, data, currency)}
                                            <div className="w-2 h-2 bg-gray-900 absolute top-full left-1/2 transform -translate-x-1/2 -translate-y-1/2 rotate-45"></div>
                                        </div>
                                    </div>
                                </div>
                                <span className="font-medium text-gray-800">{currency + item.value.toFixed(2)}</span>
                            </div>
                        ))}
                        {selectCoupon && (
                            <div className="flex justify-between text-green-600 font-medium">
                                <span>{t("Coupon Discount")} ({selectCoupon.code})</span>
                                <span>-{currency + couponDiscount.toFixed(2)}</span>
                            </div>
                        )}
                        {useWallet && walletDeduction > 0 && (
                            <div className="flex justify-between text-green-600 font-medium">
                                <span>{t("Wallet Deduction")}</span>
                                <span>-{currency + walletDeduction.toFixed(2)}</span>
                            </div>
                        )}
                        <hr className="my-1 border-gray-200" />
                        <div className="flex justify-between text-base font-bold text-gray-800">
                            <span>{t("Final Payable")}</span>
                            <span>{currency + finalPayable.toFixed(2)}</span>
                        </div>
                    </div>
                )}
            </div>

            <div className="grid grid-cols-2 my-2 gap-4">
                <button onClick={() => isRunning ? handleShowToast() : setIsModel("Payment")} className={`flex items-center justify-between p-[10px] shadow-md rounded-[10px] ${isRunning && "cursor-default"}`}>
                    <div className="flex items-center gap-2">
                        <img src={PaymentLogo} className="w-[35px]" alt="PaymentLogo" />
                        <h1>{selectPayment?.name || t("Cash")}</h1>
                    </div>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 16.75C9.80802 16.75 9.61599 16.6771 9.46999 16.5301C9.17699 16.2371 9.17699 15.762 9.46999 15.469L12.94 11.999L9.46999 8.52908C9.17699 8.23608 9.17699 7.76104 9.46999 7.46804C9.76299 7.17504 10.238 7.17504 10.531 7.46804L14.531 11.468C14.824 11.761 14.824 12.2361 14.531 12.5291L10.531 16.5291C10.384 16.6771 10.192 16.75 10 16.75Z" fill="black" />
                    </svg>
                </button>
                <button onClick={() => isRunning ? handleShowToast() : setIsModel("Coupon")} className={`flex items-center justify-between p-[10px] shadow-md rounded-[10px] ${isRunning && "cursor-default"}`}>
                    <div className="flex items-center gap-2">
                        <img src={CouponLogo} className="w-[35px]" alt="CouponLogo" />
                        <h1 className="leading-5">{selectCoupon?.code || t("Coupon")}</h1>
                    </div>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 16.75C9.80802 16.75 9.61599 16.6771 9.46999 16.5301C9.17699 16.2371 9.17699 15.762 9.46999 15.469L12.94 11.999L9.46999 8.52908C9.17699 8.23608 9.17699 7.76104 9.46999 7.46804C9.76299 7.17504 10.238 7.17504 10.531 7.46804L14.531 11.468C14.824 11.761 14.824 12.2361 14.531 12.5291L10.531 16.5291C10.384 16.6771 10.192 16.75 10 16.75Z" fill="black" />
                    </svg>
                </button>
            </div>

            <button
                onClick={isRunning ? handleShowToast : handleContinue}
                className={`w-full h-10 mt-2 rounded-[8px] ${isRunning ? "bg-[#4038ff]/50 cursor-default" : "bg-[--bg-color]"} italic tracking-[1px] font-bold text-white shadow-lg transition-transform active:scale-95 relative overflow-hidden`}
            >
                <span className="z-20 relative">
                    {t("Book for")} {currency + Number(finalPayable).toFixed(2)}
                </span>
                {isRunning && <div
                    style={{ width: `${(time / DefultTime) * 100}%` }}
                    className="absolute top-0 left-0 h-full bg-[--bg-color] z-10 transition-all ease-linear duration-[1s]"
                />}
            </button>

            {data?.bidding_run_status == 1 && <button onClick={hadnleDriverOffer} className="h-10 w-full mt-2 rounded-[8px] border border-[--bg-color] italic tracking-[1px] font-bold text-[--bg-color] transition-transform active:scale-95">
                {t("Driver Offer")}
            </button>}

            {isRunning && <button onClick={handleCancelRequest} className="h-10 w-full mt-2 rounded-[8px] border border-[--bg-color] italic tracking-[1px] font-bold text-[--bg-color] transition-transform active:scale-95">
                {t("Cancel request")}
            </button>}

        </div>




    </>
}

export default PriceModel